import { render, staticRenderFns } from "./ButtonNavLink.vue?vue&type=template&id=ea611aa2&scoped=true&"
import script from "./ButtonNavLink.vue?vue&type=script&lang=js&"
export * from "./ButtonNavLink.vue?vue&type=script&lang=js&"
import style0 from "./ButtonNavLink.vue?vue&type=style&index=0&id=ea611aa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea611aa2",
  null
  
)

export default component.exports